const localStorage = {
  set: (key, value) => {
    window.localStorage[key] = value;
  },
  get: key => (window.localStorage[key] === undefined ? '' : window.localStorage[key]),
  setObject: (key, value) => {
    try {
      window.localStorage[key] = JSON.stringify(value);
    } catch (e) {
      console.log('本地储存写入错误，若为safari浏览器请关闭无痕模式浏览。');
    }
  },
  getObject: key => JSON.parse(window.localStorage[key] || '{}'),
  remove: (key) => {
    window.localStorage.removeItem(key);
  },
};

const utils = {
  formatQueryString: (queryString) => {
    const queryArray = queryString.split('?');
    const query = queryArray[queryArray.length - 1];
    const queryObject = {};
    query.split('&').forEach((item) => {
      queryObject[item.split('=')[0]] = item.split('=')[1] ? item.split('=')[1].replace(/%3D/g, '') : '';
    });
    return queryObject;
  },
  formatQuery: (queryString) => {
    let data = {};
    if (queryString.query) {
      data = JSON.parse(atob(queryString.query.replace(/%3D/g, '')));
    }

    return {
      ...queryString,
      ...data,
    };
  },
  isAndroid: () => /android/.test(navigator.userAgent.toLowerCase()),
};

export {
  localStorage,
  utils,
};
